import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  public _token: string = null;

  constructor(public _Auth: AuthService) {}

  public GetTokenByHeader() {
    let currentUser = this._Auth.userData;
    if (currentUser && currentUser.token) {
      this._token = currentUser.token;

      let _headers: HttpHeaders = new HttpHeaders({
        Authorization: 'Bearer ' + this._token,
      });
      return _headers;
    }
  }
}
